import { MenuIdHelpCenterManagement } from '@jira/navigation-apps__constants/src/MenuIdHelpCenterManagement.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterManagementRoute } from '@jira/router-routes__help-center-management-routes/src/helpCenterManagementRoute.tsx';
import { helpCenterManagementAppEntryPoint as main } from '@jira/spa-apps__help-center-management/src/helpCenterManagementAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { expVal } from '@atlassian/jira-feature-experiments';

const helpCenterManagementRoutePageEntryPoint: ReturnType<typeof createPageEntryPoint> =
	createPageEntryPoint({
		main,
	});

export const helpCenterManagementRouteEntry: Route = createEntry(helpCenterManagementRoute, () => ({
	group: 'helpcenter-management',
	perfMetricKey: 'helpcenter.management',
	ufoName: 'help-center-ufo-helphubsmanagement',
	meta: {
		reporting: {
			id: 'helpCenterManagement',
			packageName: 'jiraSpaAppsHelpCenterManagement',
			teamName: 'JSM Megatron',
		},
	},
	layout: globalLayout,
	navigation: {
		menuId: MenuIdHelpCenterManagement,
	},
	entryPoint: () =>
		expVal('jira_sidebar_show_helpcenter', 'isEnabled', false)
			? helpCenterManagementRoutePageEntryPoint
			: notFoundPageEntrypoint,
	resources: [...getNavigationResources()],
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
